import React, { useState, useContext } from "react";
import styles from "./styles/PosCartTicket.module.css";
import DataContext from "../../../context/DataContext";
import { formatDateToLocalDate } from "../../../utils/utils";
import { calculateValues } from "../../../utils/utils";
import POSDataContext from "../../../context/POSDataContext";
import ButtonExpand from "../button_expand/ButtonExpand";
import CloseButton from "../close_button/CloseButton";
import useNumberFormat from "../../../hooks/useNumberFormat";
import { ReactComponent as IconBill } from "../../../assets/bill-1.svg";
import { ReactComponent as IconTicket } from "../../../assets/ticket.svg";

import { ReactComponent as IconTax } from "../../../assets/tax.svg";
/**
 * SideTicket component
 */
const PosCartTicket = ({
    ticket,

    currency,

    handleDelete,
    tax,
}) => {
    const total = ticket?.subTotal;
    const formatNum = useNumberFormat();
    return (
        <div
            role="button"
            className={`${styles.main_ticket_container}   flex-container`}
        >
            <div className={`${styles.info_container} v-flex-container`}>
                <div className={`${styles.ticket_info} ${styles.number_tag}`}>
                    <span>
                        <IconTicket
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {ticket?.productCode}
                </div>
                <div
                    className={`${styles.ticket_info} ${styles.ticket_hide_info} ${styles.tax_tag} `}
                >
                    <span>
                        <IconTax
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {`${currency}${formatNum(tax)}`}
                </div>
                <div className={`${styles.ticket_info}  ${styles.amount_tag}`}>
                    <span>
                        <IconBill
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {`${currency}${formatNum(total)}`}
                </div>
            </div>
            <div className={`${styles.close_button_container} flex-container`}>
                <CloseButton
                    tab={true}
                    tabBackground={true}
                    onClickFuction={() => handleDelete(ticket?.cartItemID)}
                />
            </div>
        </div>
    );
};

export default PosCartTicket;
